/**
 * Shared display helpers for Bilt QR / share / sticker surfaces.
 * Keeps URL labels and brand asset paths consistent across canvases.
 */

/** Black-on-transparent B-mark for vinyl lockups and dark-on-light UI. */
export const BILT_MARK_MONO_SRC = '/brand/bilt-mark-mono.png';

/** White-on-transparent badge (from the official mark) for dark surfaces. */
export const BILT_BADGE_SRC = '/brand/bilt-badge.png';

/** Default print/share accent (Bilt orange). Accents never tint QR modules. */
export const BILT_ACCENT_DEFAULT = '#f97316';

/**
 * Normalize a share URL into the uppercase build path shown under branded QRs,
 * e.g. "BILTSPEC.COM/USER/BUILD".
 */
export function formatBiltBuildUrlLabel(urlOrPath: string): string {
  const trimmed = (urlOrPath || '').trim();
  if (!trimmed) return 'BILTSPEC.COM';
  try {
    const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const parsed = new URL(withScheme);
    const host = parsed.hostname.replace(/^www\./i, '').toUpperCase();
    const path = parsed.pathname.replace(/\/+$/, '').replace(/^\//, '').toUpperCase();
    return path ? `${host}/${path}` : host;
  } catch {
    return trimmed
      .replace(/^https?:\/\//i, '')
      .replace(/^www\./i, '')
      .replace(/\/+$/, '')
      .toUpperCase();
  }
}
